import { YodaBorderRadius, YodaColors, YodaFontSize, YodaFontWeight } from 'yoda-ui/yodaTheme';

export const selectStyle = {
  '& .MuiOutlinedInput-root': {
    borderRadius: YodaBorderRadius.small,
    paddingLeft: '6px',

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: YodaColors.textSecondary,
    },

    '& input::placeholder': {
      color: YodaColors.gray3,
      opacity: 0.8,
    },
  },

  '& + p.Mui-error': {
    fontWeight: 300,
  },
};

export const textFieldStyle = {
  '& label': {
    fontSize: YodaFontSize.medium,
    fontWeight: 300,
    lineHeight: '1.2rem',
  },

  '& .MuiOutlinedInput-root': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: YodaColors.textSecondary,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: YodaColors.textSecondary,
    },
  },

  '& .MuiAutocomplete-input': {
    fontSize: YodaFontSize.medium,
    fontWeight: YodaFontWeight.light,
    height: '15px',

    '&::placeholder': {
      color: YodaColors.textSecondary,
      opacity: 1,
    },

    '& + input::placeholder': {
      color: YodaColors.textSecondary,
      opacity: 1,
    },
  },

  '& input::placeholder': {
    color: YodaColors.textSecondary,
    opacity: 1,
    fontSize: YodaFontSize.medium,
  },

  '& .MuiAutocomplete-endAdornment': {
    marginRight: '6px',
  },
};
